import { useMemo } from "@wordpress/element";

/**
 * Parse spacing string from database to object
 * @param {string} spacingString - JSON string like '{"top":"12px","right":"12px","bottom":"12px","left":"12px"}'
 * @returns {Object} Object with top, right, bottom, left properties (defaults to "0" if missing)
 */
export const useSpacingObject = (spacingString) => {
    return useMemo(() => {
        // Default object
        const defaultSpacing = {
            top: "0",
            right: "0",
            bottom: "0",
            left: "0",
        };

        // If object provided, return it immediately
        if (spacingString && typeof spacingString === "object") {
            return spacingString;
        }

        // If empty or invalid, return defaults
        if (!spacingString || typeof spacingString !== "string") {
            return defaultSpacing;
        }

        try {
            const parsed = JSON.parse(spacingString);

            // Ensure it's an object
            if (typeof parsed !== "object" || parsed === null) {
                return defaultSpacing;
            }

            // Merge with defaults to ensure all directions exist
            return {
                top: parsed.top || "0",
                right: parsed.right || "0",
                bottom: parsed.bottom || "0",
                left: parsed.left || "0",
            };
        } catch (error) {
            console.error("Failed to parse spacing string:", error);
            return defaultSpacing;
        }
    }, [spacingString]);
};
